import { render } from "./ProjectTile.vue?vue&type=template&id=5827bcf1"
import script from "./ProjectTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ProjectTile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5827bcf1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5827bcf1', __exports__)) {
    api.reload('5827bcf1', __exports__)
  }
  
  module.hot.accept("./ProjectTile.vue?vue&type=template&id=5827bcf1", () => {
    api.rerender('5827bcf1', render)
  })

}


export default __exports__